var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("menu.news")))]),_c('blog-list',{attrs:{"forceAll":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }